import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import { getFundsFlow } from "../../api/accountApi";
import "../Attendance/Attendance.css";

/**
 * Direct port of digicampusbd's `general-accounts-report-funds-flow`
 * ("Financial Fund Summary") — month-by-month running balance of the
 * cash-equivalent ledgers across one full year, opening balance carried
 * forward from the prior month's closing. Confirmed via
 * `GeneralAccountReportService.fundsFlow`'s single per-date native query
 * plus its in-Java running-balance loop — new `GET
 * /api/accounts/vouchers/reports/funds-flow` mirrors that logic. Only months
 * up to the current real month are shown for the current year (matching the
 * old app's own "not yet reached" filtering); a year already fully in the
 * past shows all 12.
 */
export default function FundsFlowPage() {
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    setError("");
    setLoading(true);
    try {
      setData(await getFundsFlow(year));
    } catch (err) {
      setError("Failed to load funds flow.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Financial Fund Summary</h1>
      </div>
      {error && <p style={{ color: "var(--color-danger)" }}>{error}</p>}
      <div className="attendance-filters">
        <label>
          Year
          <input type="number" value={year} onChange={(e) => setYear(Number(e.target.value))} />
        </label>
        <button type="button" className="btn-primary" onClick={handleSearch}>
          Search
        </button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        data && (
          <div className="table-scroll">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>Month</th>
                  <th>Opening Balance</th>
                  <th>Closing Balance</th>
                  <th>Funds Flow</th>
                </tr>
              </thead>
              <tbody>
                {data.months.map((m, i) => (
                  <tr key={i}>
                    <td>{m.monthName}</td>
                    <td>{m.openingBalance.toFixed(2)}</td>
                    <td>{m.closingBalance.toFixed(2)}</td>
                    <td>{m.fundsFlow.toFixed(2)}</td>
                  </tr>
                ))}
                {data.months.length === 0 && (
                  <tr>
                    <td colSpan={4}>No months to show for this year.</td>
                  </tr>
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td style={{ fontWeight: 800 }}>Year Total</td>
                  <td>
                    <strong>{data.totalOpeningBalance.toFixed(2)}</strong>
                  </td>
                  <td>
                    <strong>{data.totalClosingBalance.toFixed(2)}</strong>
                  </td>
                  <td>
                    <strong>{data.totalFundsFlow.toFixed(2)}</strong>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )
      )}
    </MainLayout>
  );
}
